var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.76849 3.2998H28.248C29.0565 3.2998 29.7 3.9433 29.7 4.7518V28.2478C29.7 29.0398 29.0565 29.6998 28.248 29.6998H21.516V19.4698H24.948L25.4595 15.4933H21.516V12.9523C21.516 11.7973 21.846 11.0053 23.496 11.0053H25.608V7.44131C25.245 7.39181 23.991 7.2928 22.539 7.2928C19.4865 7.2928 17.4075 9.1408 17.4075 12.5563V15.4933H13.959V19.4698H17.4075V29.6998H4.76849C4.38186 29.6998 4.01082 29.5474 3.73589 29.2755C3.46096 29.0037 3.30433 28.6344 3.29999 28.2478V4.7518C3.29999 3.9433 3.95999 3.2998 4.76849 3.2998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.6a42936efac52b2d94b5ca58fc0ae518.svg";
export { ForwardRef as ReactComponent };